import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=cbf9ae7c&scoped=true"
import script from "./Dish.vue?vue&type=script&lang=ts"
export * from "./Dish.vue?vue&type=script&lang=ts"
import style0 from "./Dish.vue?vue&type=style&index=0&id=cbf9ae7c&prod&lang=scss&scoped=true"
import style1 from "./Dish.vue?vue&type=style&index=1&id=cbf9ae7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf9ae7c",
  null
  
)

export default component.exports